module.exports = __webpack_public_path__ + "components/incentive/static/remove-2efc6933a9a24824872650de6dd398e8.svg";